import { render, staticRenderFns } from "./AppointmentDetailsNow.vue?vue&type=template&id=dd40443e"
import script from "./AppointmentDetailsNow.vue?vue&type=script&lang=js"
export * from "./AppointmentDetailsNow.vue?vue&type=script&lang=js"
import style0 from "./AppointmentDetailsNow.vue?vue&type=style&index=0&id=dd40443e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports